// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".spinner-container[data-v-333d380a]{top:0;bottom:0;left:0;right:0;display:flex;align-items:center;justify-content:center;z-index:3000;background:rgba(0,0,0,.4)}", ""]);
// Exports
module.exports = exports;
